import React from "react";
import ReactPlayer from "react-player";
import ReplyIcon from "@material-ui/icons/Reply";
import DeleteIcon from "@material-ui/icons/Delete";
import { makeStyles } from "@material-ui/core/styles";
import { Done, DoneAll } from "@material-ui/icons";

const useStyles = makeStyles({
  myMessage: {
    float: "right",
    margin: 5,
  },
  otherMessage: {
    float: "left",
    margin: 5,
  },
  icons: {
    opacity: 0.2,
    "&:hover, &:focus": {
      opacity: 0.9,
      // transform: scale(1.5)
    },
  },
});

const VideoMessage = ({
  UserId,
  chat,
  reply,
  deleteMessage,
  src,
  doc,
  prescriptionVideoStyle,
}) => {
  const classes = useStyles();
  const owner = parseInt(UserId) === parseInt(chat.user_id);

  return (
    <div key={chat.key} className={owner ? "chat_item me" : "chat_item"}>
      <div className="main_item_chat" style={prescriptionVideoStyle}>
        <div className={owner ? classes.myMessage : classes.otherMessage}>
          <div className="text_chat">
            <ReactPlayer
              controls
              className={owner ? classes.myMessage : classes.otherMessage}
              url={src}
              width="200px"
              height="auto"
              style={{ borderRadius: "7px" }}
              UserId={UserId}
            />
          </div>
          {owner ? (
            <div
              className="control_message"
              style={{ display: "inline-block" }}
            >
              <ReplyIcon
                className="reply_message"
                style={
                  owner ? { fontSize: 20 } : { fontSize: 20, float: "left" }
                }
                onClick={() => reply(chat)}
              />
              <DeleteIcon
                className="delete_message"
                onClick={() => deleteMessage(chat)}
              />
            </div>
          ) : (
            <div
              className="control_message"
              style={{ display: "inline-block" }}
            >
              <ReplyIcon
                className="reply_message"
                style={
                  owner ? { fontSize: 20 } : { fontSize: 20, float: "left" }
                }
                onClick={() => reply(chat)}
              />
            </div>
          )}
          {doc}
        </div>
        <div className="clearfix" />
        <time>{chat.created_at}</time>
        {owner ? (
          <span className="seen">{chat.seen ? <DoneAll /> : <Done />}</span>
        ) : null}

        <div className="clearfix" />
      </div>
      <div className="clearfix" />
    </div>
  );
};

export default VideoMessage;
